import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-sales-forecast.md.
export const Route = createFileRoute('/_app/sales-forecast')({
  component: SalesForecastPage,
});

function SalesForecastPage() {
  return <ComingSoon slug="sales-forecast" />;
}
